<template>
    <div id="wrapper">
        <div class="row">
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/CAF_B_BLU.png" style="width:250px"></a>
            </div>
            
        </div>
        <div style="margin-bottom: 100px"></div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-sm" v-if="status == 'true'" style="border-style: solid; border-color: #008000;">
              <p style="color:#000000;font-size:28px;margin-top:10px;margin-bottom:10px">
                  Nota di credito autorizzata<br>
                  <!--Status: <i style="color:#008000; text-transform: uppercase;">{{status}}</i>-->
              </p>
          </div>
          <div v-else class="col-sm">
            <div style="border-style: solid; border-color: #FF0000;">
              <p style="color:#000000;font-size:28px;margin-top:10px;margin-bottom:10px">
                <!--ID pratica: <i>{{id}}</i><br>-->
                Nota di credito <i style="color:#FF0000; text-transform: uppercase;font-weight:bold;">NON</i> autorizzata<br>
              <!--Status: <i style="color:#FF0000; text-transform: uppercase;">{{status}}</i>-->
              </p>
            </div>
            <div class="form-group" style="margin-top:20px">
              <label for="note" style="font-size:18px;font-weight:bold;color:black">Note</label>
              <input type="text" class="form-control" id="note" v-model="note">
              <button type="button" class="btn float-right" style="background:#00467f;margin-top:10px;margin-bottom:10px" v-on:click="salva()">Salva</button>
            </div>
          </div>
          <div class="col-sm"></div>
        </div> 
        <div style="margin-bottom: 100px"></div>
  </div>
</template>
<script>
import NoteServices from '@/services/NoteServices';

export default {
  components: {},

  data() {
    return {
     status: false,
     id: null,
     note: null,
     token: null,
    };
  },
  methods: {
    salva: async function() {
      if (this.note == null) {
        alert("Compilare le note!");
      } else {
        console.log(`ok`);
        var response = await NoteServices.sendNote(this.token, this.note);
        // var data = response.data
        console.log(`data=${response.data}`);
        alert("Note inserite")
        this.$router.push({
            path: '/login'
        })
      }
    }
  },

  mounted() {
    this.status = this.$route.query.status;
    this.id = this.$route.query.id;
    this.token = this.$route.query.token;
    console.log("token = "+this.token);
    console.log("status = "+this.status + ", id = "+ this.id)
  }
};
</script>
<style>
</style>
